"use strict";

var _httpCore = _interopRequireDefault(require("../httpCore"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * 退出登录
 */


_httpCore.default.createApi('logout', {
  method: 'get',
  url: '/api/Account/logout'
});